import React from 'react';
import { Link } from 'react-router-dom';

import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

import { MenuItem } from 'types/global';

import { LocalOffer as Icon } from '@mui/icons-material';

type Props = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
	open?: boolean;
};

export default function ProductCategories({ selected, onSelect, open }: Props) {
	return (
		<ListItem
			button
			component={Link}
			to="/product/categories"
			selected={selected === MenuItem.ProductCategories}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) =>
				onSelect(event, MenuItem.ProductCategories)
			}
		>
			<ListItemIcon>
				<Icon />
			</ListItemIcon>
			{open && <ListItemText primary={'Categorías'} />}
		</ListItem>
	);
}
